import React, { Component } from "react";
import Popup from "../Popup/Popup";
import Strings from "@my-dld/assets/strings";
import { JQModal } from "../Popup/Utils";

interface Props {
	procedureNumber?: string;
	onDismiss: () => void;
}

interface State {

}

class RTRegSuccessPopup extends Component<Props, State> {
	render() {
		const { procedureNumber } = this.props;
		return <Popup
			id={ "RTRegSuccessPopup" }
			modalMainContainer={ "modal fade" }
			clickOutsideToDismiss={ false }
			showCloseButton={ true }
			closeClass={ "close modal-close-svg-icon" }
			closeSpanClass={ "close-svg-icon" }
			modalBodyContainer={ "modal-body" }
			showIcon={ false }
			title={ Strings.confirmation }
			onDismiss={ this.dismissModel }>
			<div className="">
				<div className="check-icon">
					<i className="fa fa-check"/>
				</div>
				<p className="text-center">{ Strings.rt_registration_success }</p>
				<div className="refn-box">
					{ Strings.Procedure_No_Label }: <span>{ procedureNumber }</span>
				</div>
				<div className="alert-light-grey d-block">
					<b>{ Strings.next_step }</b>: { Strings.rt_registration_next_step }
				</div>
			</div>
		</Popup>;
	}

	private dismissModel = () => {
		JQModal( "RTRegSuccessPopup" ).hide();
		if ( this.props.onDismiss )
			this.props.onDismiss();
	};
}

export default RTRegSuccessPopup;
